export const getStandardHeader = () => {
  const header = new Headers();
  const token = localStorage.getItem("token");
  header.set("Authorization", "Token " + token);
  header.set("Accept", "application/json");
  header.set("Content-Type", "application/json");
  return header;
};